module.exports = __webpack_public_path__ + "img/11.4bf8ad3a.jpg";